module.exports = "/_next/static/images/oops-search-empty-2bef4031e5d489534eef7d0b3d0d6b80.svg";